export default "__VITE_ASSET__Y$zvGkYB__"